import React, { useState, useEffect } from 'react';
import { TabContent, TabPane, Nav, NavItem, NavLink } from 'reactstrap';
import useSettingsStore from '../../stores/settingsStore';

const Offsidebar = () => {
  const [activeTab, setActiveTab] = useState('settings');
  const [offsidebarReady, setOffsidebarReady] = useState(false);

  // Zustand store hooks
  const settings = useSettingsStore((state) => state.settings);
  const changeSetting = useSettingsStore((state) => state.changeSetting);

  useEffect(() => {
    setOffsidebarReady(true);
  }, []);

  const handleSettingCheckbox = (event) => {
    const { name, checked } = event.target;
    changeSetting(name, checked);
  };

  const handleThemeRadio = (event) => {
    const { value } = event.target;
    changeSetting('theme', value);
    // Apply the theme dynamically
    const linkElement = document.getElementById('theme-stylesheet');
    if (linkElement) {
      linkElement.href = value;
    }
  };

  const toggle = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  if (!offsidebarReady) return null;

  // Define theme colors dynamically
  const themeColors = {
    'themes/theme-a.css': ['bg-info', 'bg-info-light'],
    'themes/theme-b.css': ['bg-green', 'bg-green-light'],
    'themes/theme-c.css': ['bg-purple', 'bg-purple-light'],
    'themes/theme-d.css': ['bg-danger', 'bg-danger-light'],
    'themes/theme-e.css': ['bg-info-dark', 'bg-info'],
    'themes/theme-f.css': ['bg-green-dark', 'bg-green'],
    'themes/theme-g.css': ['bg-purple-dark', 'bg-purple'],
    'themes/theme-h.css': ['bg-danger-dark', 'bg-danger'],
  };

  const preventPropagation = (event) => {
    event.stopPropagation(); // Prevent clicks inside the offsidebar from propagating
  };

  return (
    <aside className="offsidebar" onClick={preventPropagation}>
      {/* START Off Sidebar (right) */}
      <nav>
        <div>
          {/* Nav tabs */}
          <Nav tabs justified>
            <NavItem>
              <NavLink className={activeTab === 'settings' ? 'active' : ''} onClick={() => toggle('settings')}>
                <em className="icon-equalizer fa-lg"></em>
              </NavLink>
            </NavItem>
          </Nav>
          {/* Tab panes */}
          <TabContent activeTab={activeTab}>
            <TabPane tabId="settings">
              <h3 className="text-center text-thin mt-4">Settings</h3>
              <div className="p-2">
                <h4 className="text-muted text-thin">Themes</h4>
                <div className="row row-flush mb-2">
                  {Object.keys(themeColors).map((theme, index) => (
                    <div className="col-3 mb-3" key={index}>
                      <div className="setting-color">
                        <label>
                          <input
                            type="radio"
                            name="theme"
                            checked={settings.theme === theme}
                            value={theme}
                            onChange={handleThemeRadio}
                          />
                          <span className="icon-check"></span>
                          <span className="split">
                            <span className={`color ${themeColors[theme][0]}`}></span>
                            <span className={`color ${themeColors[theme][1]}`}></span>
                          </span>
                          <span className="color bg-white"></span>
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div className="p-2">
                <h4 className="text-muted text-thin">Layout</h4>
                <div className="clearfix">
                  <p className="float-left">Fixed</p>
                  <div className="float-right">
                    <label className="switch">
                      <input
                        id="chk-fixed"
                        type="checkbox"
                        name="isFixed"
                        checked={settings.isFixed}
                        onChange={handleSettingCheckbox}
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
                <div className="clearfix">
                  <p className="float-left">Boxed</p>
                  <div className="float-right">
                    <label className="switch">
                      <input
                        id="chk-boxed"
                        type="checkbox"
                        name="isBoxed"
                        checked={settings.isBoxed}
                        onChange={handleSettingCheckbox}
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
              <div className="p-2">
                <h4 className="text-muted text-thin">Aside</h4>
                <div className="clearfix">
                  <p className="float-left">Collapsed</p>
                  <div className="float-right">
                    <label className="switch">
                      <input
                        id="chk-collapsed"
                        type="checkbox"
                        name="isCollapsed"
                        checked={settings.isCollapsed}
                        onChange={handleSettingCheckbox}
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
                <div className="clearfix">
                  <p className="float-left">Collapsed Text</p>
                  <div className="float-right">
                    <label className="switch">
                      <input
                        id="chk-collapsed-text"
                        type="checkbox"
                        name="isCollapsedText"
                        checked={settings.isCollapsedText}
                        onChange={handleSettingCheckbox}
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
                <div className="clearfix">
                  <p className="float-left">Float</p>
                  <div className="float-right">
                    <label className="switch">
                      <input
                        id="chk-float"
                        type="checkbox"
                        name="isFloat"
                        checked={settings.isFloat}
                        onChange={handleSettingCheckbox}
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
                <div className="clearfix">
                  <p className="float-left">Hover</p>
                  <div className="float-right">
                    <label className="switch">
                      <input
                        id="chk-hover"
                        type="checkbox"
                        name="asideHover"
                        checked={settings.asideHover}
                        onChange={handleSettingCheckbox}
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
                <div className="clearfix">
                  <p className="float-left">Show Scrollbar</p>
                  <div className="float-right">
                    <label className="switch">
                      <input
                        id="chk-scrollbar"
                        type="checkbox"
                        name="asideScrollbar"
                        checked={settings.asideScrollbar}
                        onChange={handleSettingCheckbox}
                      />
                      <span></span>
                    </label>
                  </div>
                </div>
              </div>
            </TabPane>
          </TabContent>
        </div>
      </nav>
    </aside>
  );
};

export default Offsidebar;
